module.exports = __webpack_public_path__ + "static/media/Avatars_Male_New-14.79d29e95.png";